import * as React from 'react';
import * as constants from '../constants';
import crawlingChorusCover from '../resources/images/albumCover.png';
import debuggerCover from '../resources/images/debuggerCover.png';
import newMexicoCover from '../resources/images/newMexicoCover.png';
import bonVoyageCover from '../resources/images/bonVoyageCover.jpg';

function App() {
  return (
    <div className='layout'>
      <header>
        <h1>RIPSHIP</h1>
      </header>
      <div className='content'>
        {/* <h2>UTOPIA MUSIC VIDEO</h2>
        <VideoBlock videoSrc='https://www.youtube.com/embed/2oXqlqidnBM?si=p7jFUHhgumqL_hHH'></VideoBlock> */}
        <h2>SHOWS</h2>
        <EventBlock mainText='16 APR - SOLINGEN, DE - WALDMEISTER' />
        <EventBlock mainText='17 APR - LEEUWARDEN, NL - DE BEATRIKS' href='https://debeatriks.nl/en/events/the-boojums-support/' />
        <EventBlock mainText='18 APR - GHENT, BE - BADLANDS FESTIVAL' href='https://apps.ticketmatic.com/widgets/democrazy/flow/tickets?event=786436605273&l=nl#!/addtickets' />
        <EventBlock mainText='19 APR - LIÈGE, BE - PÉNICHE LÉGIA' href='https://my.weezevent.com/sick-thoughts-garage-rock-us-guest' />
        <EventBlock mainText='20 APR - BINCHE, BE - LA BINCHOISE' />
        <EventBlock mainText='22 APR - VIENNA, AT - KRAMLADEN' href='https://kupfticket.com/en/events/ripship-nz' />
        <EventBlock mainText='23 APR - WROCLAW, PL - ART CAFE KALAMBUR' />
        <EventBlock mainText='24 APR - LEIPZIG, DE - M.V.B.' />
        <EventBlock mainText='25 APR - WALTROP, DE - COMFORT ONE STUDIO' />
        <EventBlock mainText='26 APR - OFFENBACH, DE - HAFEN 2' href='https://loveyourartist.com/en/events/as-fanning-support-offenbach-am-main-646KP5' />
        <EventBlock mainText='29 APR - HOSSEGOR, FR - 416 CREW' />
        <EventBlock mainText='30 APR - SANTANDER, ES - ROCK BEER THE NEW' />
        <EventBlock mainText='1 MAY - VIGO, ES - SALA RADAR' />
        <EventBlock mainText='2 MAY - ALCOBAÇA, PT - PEDRA ROCK FESTIVAL' />
        <EventBlock mainText='3 MAY - LISBON, PT - SALÓN FUZZ / CASA CAPITÃO' />
        <EventBlock mainText='5 MAY - GRANADA, ES - PLANTA BAJA' href='https://entradas.conciertos.club/es/events/serpiente-negra-presenta-ripship' />
        <EventBlock mainText='7 MAY - LUGO, ES - FA CE LA FESTIVAL' href='https://www.ingresse.com/facela-fest-10/?refresh=1766486957461' />
        <EventBlock mainText='8 MAY - FAFE, PT - AVENIDA' />
        <EventBlock mainText='9 MAY - TOLOSA, ES - BONBERENEA' />
        <EventBlock mainText='11 MAY - BRUSSELS, BE - CHAFF' />
        <h2>RELEASES</h2>
        <ReleaseBlock
          mainText='BON VOYAGE REMIXES'
          subText='ALPHABETHEAD + AMAMELIA'
          spotifyHref={constants.BON_VOYAGE_SPOTIFY}
          youtubeHref={constants.BON_VOYAGE_YOUTUBE}
          rightContent={
            <img alt='A sattelite flying through space' src={bonVoyageCover} />
          }
        />
        <ReleaseBlock
          mainText='CRAWLING CHORUS'
          subText='ALBUM OUT NOW'
          spotifyHref={constants.CRAWLING_CHORUS_SPOTIFY}
          bandcampHref={constants.CRAWLING_CHORUS_BANDCAMP}
          youtubeHref={constants.CRAWLING_CHORUS_YOUTUBE}
          rightContent={
            <img
              alt='the crawling chorus album cover, a sludgy mass of debris with a monsterous face'
              src={crawlingChorusCover}
            />
          }
        />
        <ReleaseBlock
          mainText='DEBUGGER'
          subText='SINGLE OUT NOW'
          spotifyHref={constants.DEBUG_SPOTIFY}
          bandcampHref={constants.DEBUG_BANDCAMP}
          youtubeHref={constants.DEBUG_YOUTUBE}
          rightContent={
            <img
              alt='the debugger single cover, a woman wearing a gas mask holds a can of fly spray to the camera'
              src={debuggerCover}
            />
          }
        />
        <ReleaseBlock
          mainText='NEW MEXICO'
          subText='SINGLE OUT NOW'
          spotifyHref={constants.NEWMEX_SPOTIFY}
          bandcampHref={constants.NEWMEX_BANDCAMP}
          youtubeHref={constants.NEWMEX_YOUTUBE}
          rightContent={
            <img
              alt='the new mexico single cover, the two band members pose atop a rocky mountain'
              src={newMexicoCover}
            />
          }
        />
        <h2>SOCIAL LINKS</h2>
        <section className='socialMediaWrapper'>
          <LinkBlock mainText='instagram' href={constants.instagramPath} />
          <LinkBlock mainText='spotify' href={constants.spotifyPath} />
          <LinkBlock mainText='bandcamp' href={constants.bandcampPath} />
          <LinkBlock mainText='tiktok' href={constants.tiktokPath} />
          <LinkBlock mainText='youtube' href={constants.youtubePath} />
          <LinkBlock mainText='facebook' href={constants.facebookPath} />
        </section>
      </div>
    </div>
  );
}

function LinkBlock(props) {
  return (
    <a
      className='linkBlock divBorder'
      rel='noreferrer nofollow'
      target='blank'
      href={props.href}
    >
      <span className='mainTextMed'>{props.mainText}</span>
      <span className='subText'>{props.subText}</span>
    </a>
  );
}

function EventBlock(props) {
  if (props.href) {
    return (
      <a
        className='linkBlock divBorder'
        rel='noreferrer nofollow'
        target='blank'
        href={props.href}
      >
        <span className='mainTextMed'>{props.mainText}</span>
      </a>
    );
  }
  return (
    <div className='linkBlock divBorder'>
      <span className='mainTextMed'>{props.mainText}</span>
      <span className='subText'>TICKETS TBA</span>
    </div>
  );
}

function VideoBlock({ videoSrc }) {
  return (
    <div
      style={{
        position: 'relative',
        paddingBottom: '56.25%',
        height: 0,
        overflow: 'hidden',
      }}
    >
      <iframe
        src={videoSrc}
        title='YouTube video player'
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          border: 0,
        }}
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        referrerPolicy='strict-origin-when-cross-origin'
        allowFullScreen
      />
    </div>
  );
}

function ReleaseBlock(props) {
  const links = [
    { linkText: 'spotify', href: props.spotifyHref },
    { linkText: 'youtube', href: props.youtubeHref },
    props.bandcampHref
      ? { linkText: 'bandcamp', href: props.bandcampHref }
      : null,
  ].filter(Boolean);

  return (
    <article className='releaseWrapper'>
      <div className='blockWrapper'>
        <div className='blockWrapperLeft divBorder'>
          <h3 className='mainText'>{props.mainText}</h3>
          <span className='subText'>
            {props.subTextHRef ? (
              <a
                rel='noreferrer nofollow'
                target='blank'
                href={props.subTextHRef}
              >
                {props.subText}
              </a>
            ) : (
              props.subText
            )}
          </span>
        </div>
        <div className='blockWrapperRight'>{props.rightContent}</div>
      </div>
      <div className='socialBlockWrapper'>
        {links.map((link) => (
          <a
            rel='noreferrer nofollow'
            target='blank'
            href={link.href}
            className='socialWrapper divBorder'
          >
            {link.linkText}
          </a>
        ))}
      </div>
    </article>
  );
}

export default App;
